import {
	ActivateItemMutation,
	AddItemMutation,
	AddItemUpgradeMutation,
	AssignItemGlAccountsMutation,
	ClearItemContainerConfigOverrideMutation,
	ClearItemNoteMutation,
	DeactivateItemUpgradeMutation,
	DeleteItemMutation,
	InactivateItemMutation,
	MergeItemMutation,
	PatchItemMutation,
	RemoveItemMinShipQtyMutation,
	RemoveItemSubstitutionMutation,
	SetItemBatchTrackingMutation,
	SetItemContainerConfigOverrideMutation,
	SetItemNoteMutation,
	SetItemPriceLabelMutation,
	SetItemShippingUomsMutation,
	ToggleItemUpgradeDefaultMutation,
	UpdateItemAttributesMutation,
	UpdateItemMutation,
	UpdateItemUpgradeMutation,
	UploadItemImageMutation
} from "~/gql/mutations/items.generated";
import { GetItemProgramsQuery } from "~/gql/queries/itemPrograms.generated";
import {
	GetEffectiveIncomeGlAccountQuery,
	GetItemCategoriesQuery,
	GetItemCombinePreviewQuery,
	GetItemGlAccountCoverageQuery,
	GetItemGroupsQuery,
	GetItemQuery,
	GetItemSubcategoriesQuery,
	GetItemsQuery
} from "~/gql/queries/items.generated";

export const itemsEndpoints = {
	ActivateItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: ActivateItemMutation) => res
	},
	AddItem: {
		invalidatesTags: ["Items", "Learning"] as AddTagTypes,
		transformResponse: (res: AddItemMutation) => res
	},
	AddItemUpgrade: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: AddItemUpgradeMutation) => res
	},
	AssignItemGlAccounts: {
		invalidatesTags: ["Items", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: AssignItemGlAccountsMutation) => res
	},
	ClearItemContainerConfigOverride: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: ClearItemContainerConfigOverrideMutation) => res
	},
	ClearItemNote: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: ClearItemNoteMutation) => res
	},
	DeactivateItemUpgrade: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: DeactivateItemUpgradeMutation) => res
	},
	DeleteItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: DeleteItemMutation) => res
	},
	GetEffectiveIncomeGlAccount: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetEffectiveIncomeGlAccountQuery) => res
	},
	GetItem: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemQuery) => res
	},
	GetItemCategories: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemCategoriesQuery) => res
	},
	GetItemCombinePreview: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemCombinePreviewQuery) => res
	},
	GetItemGlAccountCoverage: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemGlAccountCoverageQuery) => res
	},
	GetItemGroups: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemGroupsQuery) => res
	},
	GetItemListGroups: {
		providesTags: ["Items"] as AddTagTypes
	},
	GetItemPrograms: {
		providesTags: ["Programs"] as AddTagTypes,
		transformResponse: (res: GetItemProgramsQuery) => res
	},
	GetItems: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemsQuery) => res
	},
	GetItemSubcategories: {
		providesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: GetItemSubcategoriesQuery) => res
	},
	GetStripeTaxCodes: {
		keepUnusedDataFor: 3600
	},
	InactivateItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: InactivateItemMutation) => res
	},
	MergeItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: MergeItemMutation) => res
	},
	PatchItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: PatchItemMutation) => res
	},
	RemoveItemMinShipQty: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: RemoveItemMinShipQtyMutation) => res
	},
	RemoveItemSubstitution: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: RemoveItemSubstitutionMutation) => res
	},
	SetItemBatchTracking: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: SetItemBatchTrackingMutation) => res
	},
	SetItemContainerConfigOverride: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: SetItemContainerConfigOverrideMutation) => res
	},
	SetItemNote: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: SetItemNoteMutation) => res
	},
	SetItemPriceLabel: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: SetItemPriceLabelMutation) => res
	},
	SetItemShippingUoms: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: SetItemShippingUomsMutation) => res
	},
	ToggleItemUpgradeDefault: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: ToggleItemUpgradeDefaultMutation) => res
	},
	UpdateItem: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: UpdateItemMutation) => res
	},
	UpdateItemAttributes: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: UpdateItemAttributesMutation) => res
	},
	UpdateItemUpgrade: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: UpdateItemUpgradeMutation) => res
	},
	UploadItemImage: {
		invalidatesTags: ["Items"] as AddTagTypes,
		transformResponse: (res: UploadItemImageMutation) => res
	}
};
